export enum Roles {
  ADMIN = "fullAccess",
  MENAGER = "order.read,paymentdata.read,transaction.read,paymentprovider.read,cryptoexchange.read",
  LOADER = "LOADER",
}
